import { Button } from "@truevault/aquilo";
import React from "react";
import "../../../../../sass/components/organisms/cards/ExternalArticleCard.scss";
import IconExternalArticle from "../../../../../static/assets/images/icon-external-article.svg";

export type ExternalArticleCardProps = {
  title: string;
  buttonText: string;
  buttonOnClick: () => void;
  description?: string;
  iconComponent?: React.ReactNode;
};

export const ExternalArticleCard = ({
  title,
  buttonText,
  buttonOnClick,
  description = null,
  iconComponent = <IconExternalArticle />,
}: ExternalArticleCardProps) => {
  return (
    <div className="tw-boundary external-article-card">
      <div className="flex items-center">
        {iconComponent && <div style={{ flexShrink: 0 }}>{iconComponent}</div>}
        <div className="external-article-card--title">{title}</div>
      </div>
      {description && <div className="external-article-card--description">{description}</div>}
      <Button size="m" color="tertiary" onClick={buttonOnClick}>
        {buttonText}
      </Button>
    </div>
  );
};
